import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.002 11.865c.497 0 .923-.177 1.276-.531.353-.354.53-.78.53-1.278s-.178-.923-.532-1.276a1.745 1.745 0 0 0-1.278-.53c-.497 0-.923.177-1.276.532-.353.354-.53.78-.53 1.277 0 .498.178.923.532 1.277.354.353.78.53 1.278.53ZM12 19.514c1.956-1.752 3.454-3.432 4.491-5.04 1.038-1.608 1.557-3.017 1.557-4.226 0-1.823-.58-3.322-1.737-4.496C15.152 4.578 13.715 3.99 12 3.99c-1.715 0-3.152.588-4.31 1.762-1.159 1.174-1.738 2.673-1.738 4.496 0 1.21.519 2.618 1.557 4.226 1.037 1.608 2.535 3.288 4.491 5.04m0 1.996c-2.517-2.181-4.404-4.21-5.662-6.089-1.257-1.878-1.886-3.602-1.886-5.173 0-2.308.746-4.176 2.24-5.605C8.183 3.214 9.953 2.5 12 2.5s3.816.714 5.309 2.143c1.493 1.43 2.239 3.297 2.239 5.605 0 1.57-.629 3.295-1.886 5.173C16.404 17.3 14.517 19.33 12 21.51" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }